import type { CSSProperties, ReactNode } from "react";

const EDGE_SPACE_MARKER_STYLE: CSSProperties = {
	display: "inline-block",
	width: "0.35em",
	minHeight: "1em",
	verticalAlign: "middle",
	background: "var(--coapp-gradient-yellow)",
	borderRadius: 2,
	margin: "0 1px",
};

function spaceMarkers(count: number, keyPrefix: string): ReactNode[] {
	return Array.from({ length: count }, (_, i) => (
		<span key={`${keyPrefix}-${i}`} style={EDGE_SPACE_MARKER_STYLE} />
	));
}

/** Visible CoApp gradient slot per leading/trailing normal space in committed literal values. */
export function formatLiteralEdgeWhitespace(value: string): string | ReactNode[] {
	if (!/^ +| +$/.test(value)) return value;

	if (/^ *$/.test(value)) {
		return spaceMarkers(value.length, "only");
	}

	const leadingSpaces = value.match(/^ +/);
	const trailingSpaces = value.match(/ +$/);
	const core = value.replace(/^ +/, "").replace(/ +$/, "");
	const result: ReactNode[] = [];

	if (leadingSpaces) {
		result.push(...spaceMarkers(leadingSpaces[0].length, "leading"));
	}

	result.push(core);

	if (trailingSpaces) {
		result.push(...spaceMarkers(trailingSpaces[0].length, "trailing"));
	}

	return result;
}
